import React, { useEffect, useRef, useState } from "react";
import "./janelaErro.css";

let contador = 0;

// Janela modal de erro. `aviso` vem de montarAvisoErro; `aoFechar` fecha.
export default function JanelaErro({ aviso, aoFechar }) {
  const botaoFechar = useRef(null);
  const idTitulo = useRef(`janela-erro-titulo-${++contador}`);
  const [copiado, setCopiado] = useState(false);
  const temClipboard = !!(
    typeof navigator !== "undefined" &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  );

  useEffect(() => {
    setCopiado(false);
    if (botaoFechar.current) botaoFechar.current.focus();
  }, [aviso]);

  const refDialogo = useRef(null);

  useEffect(() => {
    if (!aviso) return undefined;
    const aoTeclar = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        aoFechar();
        return;
      }
      if (e.key !== "Tab" || !refDialogo.current) return;
      const botoes = refDialogo.current.querySelectorAll("button");
      if (botoes.length === 0) return;
      const primeiro = botoes[0];
      const ultimo = botoes[botoes.length - 1];
      const ativo = document.activeElement;
      const dentro = refDialogo.current.contains(ativo);
      if (e.shiftKey && (!dentro || ativo === primeiro)) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && (!dentro || ativo === ultimo)) {
        e.preventDefault();
        primeiro.focus();
      }
    };
    document.addEventListener("keydown", aoTeclar);
    return () => document.removeEventListener("keydown", aoTeclar);
  }, [aviso, aoFechar]);

  if (!aviso) return null;

  const semEspacos = aviso.codigoRastreio || "";
  const copiar = () => {
    if (!temClipboard) return;
    navigator.clipboard
      .writeText(semEspacos)
      .then(() => setCopiado(true))
      .catch(() => setCopiado(false));
  };

  const classe =
    "janela-erro" + (aviso.tipo === "negocio" ? " janela-erro--negocio" : "");

  return (
    <div
      className="janela-erro__fundo"
      onClick={(e) => {
        if (e.target === e.currentTarget) aoFechar();
      }}
    >
      <section
        className={classe}
        ref={refDialogo}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={idTitulo.current}
      >
        <div className="janela-erro__corpo">
          <h2 className="janela-erro__titulo" id={idTitulo.current}>
            {aviso.titulo}
          </h2>
          {aviso.texto && <p className="janela-erro__texto">{aviso.texto}</p>}
          {aviso.mensagens && aviso.mensagens.length > 0 && (
            <ul className="janela-erro__lista">
              {aviso.mensagens.map((m, i) => (
                <li key={i}>{m}</li>
              ))}
            </ul>
          )}
          {aviso.protocolo && (
            <div className="janela-erro__protocolo">
              <span className="janela-erro__rotulo">Protocolo para o suporte</span>
              <div className="janela-erro__linha">
                <span className="janela-erro__codigo">
                  {aviso.protocolo.split(" ").map((g, i) => (
                    <React.Fragment key={i}>
                      {i > 0 && " "}
                      <span className="janela-erro__grupo">{g}</span>
                    </React.Fragment>
                  ))}
                </span>
                <span aria-live="polite">
                  <button
                    type="button"
                    className={
                      "janela-erro__copiar" +
                      (copiado ? " janela-erro__copiar--ok" : "")
                    }
                    onClick={copiar}
                  >
                    {copiado
                      ? "Copiado"
                      : temClipboard
                      ? "Copiar"
                      : "Selecione e copie"}
                  </button>
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="janela-erro__rodape">
          <button
            type="button"
            className="janela-erro__fechar"
            ref={botaoFechar}
            onClick={aoFechar}
          >
            Fechar
          </button>
        </div>
      </section>
    </div>
  );
}
